<template>
  <div class="container" style="background: #fff">
    <div v-if="isEmpty(booking_info)" class="hab-main-info">
      <h1 class="hab-main-info__title">{{ $t('common.ticket_info_title') }}</h1>
      <div v-if="errors.common" class="panel panel--danger">
        {{ errors.common }}
      </div>
      <CompInput
          class=""
          :label="$t('common.ticket_code')"
          :placeholder="$t('common.ticket_code_placeholder')"
          :value="ticket_code"
          :required="true"
          :error="errors.ticket_code"
          @onChange="val => ticket_code = val"
      />
      <CompInput
          class=""
          :label="$t('common.phone')"
          :placeholder="$t('common.phone_placeholder')"
          :value="phone"
          :required="true"
          :error="errors.phone"
          @onChange="val => phone = val"
      />
      <CompButton
          :label="$t('common.see_ticket_info')"
          :min="150"
          :theme="1"
          :loading="loading"
          @onClick="onTicketInfo"
      />
      <div class="panel">
        <div><strong>{{ $t('common.note') }}</strong></div>
        <div>
          {{ $t('common.ticket_info_note', { phone: hotline }) }}
        </div>
      </div>
    </div>
    <div v-else class="hab-main-layout">
      <div class="payment">
        <div v-if="mode === 'success'" class="payment__methods">
          <div class="payment__title">{{ $t('book.trip_information') }}</div>
          <hr>
          <div class="payment__box">
            <strong>{{ $t('book.order_code') }}:</strong> {{ get(booking_info, 'code', '') }}
          </div>
          <div class="payment__box">
            <strong>{{ $t('book.vehicle_name') }}:</strong> {{ get(booking_info, 'company_name', '') }}
          </div>
          <div class="payment__box">
            <strong>{{ $t('book.vehicle_type') }}:</strong> {{ get(booking_info, 'vehicle_type', '') }}
          </div>
          <div class="payment__box">
            <strong>{{ $t('book.seat') }}:</strong> {{ get(booking_info, 'seat_name', '') }}
          </div>
          <div class="payment__box">
            <strong>{{ $t('book.route') }}:</strong> {{ get(booking_info, 'trip_name', '') }}
          </div>
          <div class="payment__title mb-0">{{ $t('book.pick_up_1') }}:</div>
          <div style="line-height: 24px;margin-bottom: 10px">
            {{ get(booking_info, 'pickup', '') }}<br>
            <i>{{ get(booking_info, 'pickup_address', '') }}</i><br>
            {{ $t('book.time') }}: <strong>{{ get(booking_info, 'pickup_date', '') }}</strong>
          </div>
          <div class="payment__title mb-0">{{ $t('book.drop_off_1') }}:</div>
          <div style="line-height: 24px;">
            {{ get(booking_info, 'drop_off_info', '') }}<br>
            <i>{{ get(booking_info, 'drop_off_address', '') }}</i>
          </div>
          <template v-if="qr">
            <div class="payment__title mb-0" style="margin-top: 10px">QR:</div>
            <div style="line-height: 24px;">
              <img :src="qr" />
            </div>
          </template>
          <hr>
          <div class="payment__content__item mb-10">
            <label>{{ $t('book.status') }}</label>
            <div>
              {{ statusName }}
            </div>
          </div>
          <hr>
          <div v-if="bookingStatus == 1 && get(booking_info, 'paymentUrl', '')">
            <a :href="get(booking_info, 'paymentUrl', '')" class="payment__action payment__action--pay">{{ $t('book.pay_now') }}</a>
            <hr>
          </div>
          <div v-if="!disable_cancel_function" class="payment__box payment__refunds-box">
            <strong style="width: auto; margin-bottom: 10px">{{ $t('book.cancel_refunds') }}</strong>
            <div class="panel panel--danger">
              {{ $t('book.cancel_note_common') }}
            </div>
            <comp-button
                class="payment__action payment__action--cancel"
                style="width: auto;padding: 8px 10px;"
                :loading="cancel_loading"
                :label="$t('book.cancellation_tickets')"
                @onClick="is_show_cancel_modal = true"
            />
          </div>
        </div>
        <div
            v-else-if="mode === 'error'"
            class="payment__methods"
        >
          <div class="payment__title payment__title--error">{{ $t('common.something_went_wrong') }}</div>
          <div style="text-align: center">
            <img class="img-responsive" src="/public/images/route-no-schedule.png">
            <div v-html="$t('common.something_went_wrong_content')" />
          </div>
          <div>
            <comp-button
                class="payment__action"
                label="Quay về trang chủ"
                @onClick="goHome"
            />
          </div>
        </div>
        <div
            v-else-if="mode === 'cancel'"
            class="payment__methods"
        >
          <div class="payment__title payment__title--error">{{ $t('book.ticket_cancel') }}</div>
          <div v-if="is_show_cancel_note" style="margin-bottom: 10px">
            {{ $t('book.cancel_note_1') }}
          </div>
          <div>
            <img src="/public/images/route-no-schedule.png">
          </div>
          <div>
            <comp-button
                class="payment__action payment__action--cancel"
                :label="$t('common.rebook_tickets')"
                @onClick="goHomeBooking"
            />
          </div>
        </div>
        <div class="payment__trip-info">
          <div v-if="mode === 'success'" class="payment__title">{{ $t('book.enter_information') }}</div>
          <div v-else class="payment__title">{{ $t('book.trip_information') }}</div>
          <div class="payment__content">
            <div class="payment__content__item">
              <label>{{ $t('common.customer_name') }}</label>
              <div>{{ get(booking_info, 'customer_name', '') }}</div>
            </div>
            <div class="payment__content__item">
              <label>{{ $t('common.phone') }}</label>
              <div>{{ get(booking_info, 'customer_phone', '') }}</div>
            </div>
            <div class="payment__content__item">
              <label>Email</label>
              <div>{{ get(booking_info, 'customer_email', '') }}</div>
            </div>
            <template v-if="mode === 'cancel'">
              <hr>
              <div class="payment__content__item mt-0">
                <label>{{ $t('book.vehicle_name') }}</label>
                <div>{{ get(booking_info, 'company_name', '') }}</div>
              </div>
              <div class="payment__content__item">
                <label>{{ $t('book.vehicle_type') }}</label>
                <div>{{ get(booking_info, 'vehicle_type', '') }}</div>
              </div>
              <div class="payment__content__item">
                <label>{{ $t('book.seat') }}</label>
                <div>{{ get(booking_info, 'seat_name', '') }}</div>
              </div>
              <div class="payment__content__item">
                <label>{{ $t('book.route') }}</label>
                <div>{{ get(booking_info, 'trip_name', '') }}</div>
              </div>
            </template>
          </div>
          <div class="payment__title">{{ $t('book.transaction_information') }}</div>
          <div class="payment__content">
<!--            <div class="payment__content__item">
              <label>{{ $t('book.payment_methods') }}</label>
              <div>
                {{ paymentTypeName }}
              </div>
            </div>
            <hr>-->
            <div class="flex-justify-between">
              <span>{{ $t('book.fare') }}</span>
              <div>
                <div
                    v-for="(item, key) in fareList"
                    :key="key"
                    class="t-right mb-4"
                >
                  <span>{{ item.length }} x </span><strong>{{ formatMoney(key) }}{{ currency }}</strong>
                  <div v-if="!get(booking_info, 'unchoosable', true)" class="text-12-400">{{ $t('book.seat') }} {{ item.toString() }}</div>
                </div>
              </div>
            </div>
            <hr v-if="surchargeTotal != 0 || serviceFeeFare != 0">
            <div v-if="surchargeTotal != 0" class="flex-justify-between">
              <span>{{ $t('common.surcharge') }}</span>
              <div>
                <div class="t-right mb-4">
                  <strong>{{ formatMoney(surchargeTotal) }}{{ currency }}</strong>
                </div>
              </div>
            </div>
            <div v-if="serviceFeeFare != 0" class="flex-justify-between">
              <span>{{ $t('common.service_fee_name') }}</span>
              <div>
                <div class="t-right mb-4">
                  <strong>{{ formatMoney(serviceFeeFare) }}{{ currency }}</strong>
                </div>
              </div>
            </div>
            <hr>
            <div class="flex-justify-between">
              <strong>{{ $t('book.total') }}</strong>
              <strong class="payment__total-price">{{ fareTotal }}</strong>
            </div>
          </div>
        </div>
        <div style="clear: both" />
        <div v-if="mode === 'success' && !disable_cancel_function" class="payment__box payment__refunds-box payment__refunds-box--show-sp">
          <strong style="width: auto; margin-bottom: 10px">{{ $t('book.cancel_refunds') }}</strong>
          <div class="panel panel--danger">
            {{ $t('book.cancel_note_common') }}
          </div>
          <comp-button
              class="payment__action payment__action--cancel"
              style="width: auto;padding: 8px 10px;"
              :loading="cancel_loading"
              :label="$t('book.cancellation_tickets')"
              @onClick="is_show_cancel_modal = true"
          />
        </div>
      </div>
    </div>
    <cancel-modal
      v-show="is_show_cancel_modal"
      :ticket-code="get(booking_info, 'code', '')"
      :booking-code="get(booking_info, 'booking_code', '')"
      :total-fare="amountBooking"
      :service-fee="serviceFee"
      @close="is_show_cancel_modal = false"
      @set-cancel-loading="setCancelLoading"
      @set-mode="setModeAfterCancel"
    />
  </div>
</template>

<script>
import CompInput from "../../input/index.vue";
import CompButton from "../../button/index.vue";
import CancelModal from "../cancel/modal-cancel"
import QRCode from "qrcode";
import {get, isEmpty} from "lodash";
import {formatMoney} from "../../../utils/helpers";

export default {
  components: {
    CompInput,
    CompButton,
    CancelModal
  },
  data () {
    return {
      ticket_code: '',
      phone: '',
      hotline: hotline,
      loading: false,
      booking_info: {},
      booking_success_info: {},
      cancel_loading: false,
      is_show_cancel_modal: false,
      mode: 'success',
      disable_cancel_function: false,
      is_show_cancel_note: false,
      logo_pt: appUrl + '/public/images/logo-pt.png',
      errors: {
        ticket_code: '',
        phone: '',
        common: '',
      },
      qr: ''
    }
  },
  computed: {
    fareTotal() {
      return formatMoney(this.amountBooking + this.serviceFeeFare) + this.currency
    },
    amountBooking() {
      return parseInt(this.booking_info.amount_booking)
    },
    paymentTypeName () {
      return get(this.booking_info, 'payment_type', 0) == 1 ?
          this.$t('book.payment_bank_card') :
          this.$t('book.direct_payment');
    },
    serviceFee () {
      return get(this.booking_info, 'service_fee', 0)
    },
    serviceFeeFare() {
      if (this.amountBooking === 0 || this.serviceFee === 0) {
        return 0
      }

      return this.amountBooking * this.serviceFee / 100
    },
    currency () {
      return this.$i18n.locale === "vn" ? "đ" : "VND";
    },
    fareList () {
      const results = {};
      (this.booking_info?.tickets || []).forEach(item => {
        const seatCode = item.seat.split('|')[0]
        const fare = item.fare - item.discount
        if (isEmpty(results[fare])) {
          results[fare] = [seatCode]
        } else {
          results[fare].push(seatCode)
        }
      })

      return results
    },
    bookingStatus () {
      return get(this.booking_info, 'status', 0)
    },
    statusName () {
      switch (this.bookingStatus) {
        case 1:
          return this.$t('book.successful_booking')
        case 4:
          return this.$t('book.payment_success')
        case 5:
          return this.$t('book.ticket_cancel')
      }
    },
    surchargeTotal () {
      return parseInt(get(this.booking_info, 'surcharge_total', 0))
    }
  },
  methods: {
    get,
    isEmpty,
    formatMoney,
    onTicketInfo () {
      if (this.loading || !this.validate()) {
        return
      }
      this.loading = true
      const params = {
        ticket_code: this.ticket_code,
        phone: this.phone,
      };

      this.$store.dispatch("bookingInfo", params)
          .then(async (result) => {
            const data = get(result, "data", []);
            this.loading = false
            if (!data) {
              this.errors.common = this.$t('common.something_went_wrong')
              return;
            }

            if (isEmpty(data.data)) {
              this.errors.common = this.$t('book.ticket_wrong')
              return;
            }

            const bookingInfo = data.data[0]
            const pickupTimeExpectedFull = get(bookingInfo, 'pickup_time_expected_full', null)
            const pickupDate = get(bookingInfo, 'pickup_date', '')
            let pickupMoment = moment(pickupDate, 'hh:mmA DD/MM/YYYY')
            if (pickupTimeExpectedFull) {
              pickupMoment = moment(pickupTimeExpectedFull, 'HH:mm DD/MM/YYYY')
            }
            if (bookingInfo.refundable == 0 || !pickupDate || moment().isAfter(pickupMoment)) {
              this.disable_cancel_function = true
            }

            this.booking_info = {
              pickup: get(bookingInfo, 'pickup_info', '').split('|')[0],
              pickup_date: pickupMoment.format('HH:mm  •  DD/MM/YYYY'),
              drop_off_info: get(bookingInfo, 'drop_off_info', ''),
              customer_name: get(bookingInfo, 'customer.name', ''),
              customer_phone: get(bookingInfo, 'customer.phone', ''),
              customer_email: get(bookingInfo, 'customer.email', ''),
              company_name: get(bookingInfo, 'company', ''),
              vehicle_type: get(bookingInfo, 'vehicle.vehicle_name', ''),
              seat_name: get(bookingInfo, 'seat_codes', []).toString(),
              tickets: get(bookingInfo, 'ticket.detail_info', []),
              code: get(bookingInfo, 'ticket.code', ''),
              booking_code: get(bookingInfo, 'code', ''),
              trip_name: get(bookingInfo, 'trip_name', ''),
              status: get(bookingInfo, 'status', 0),
              payment_type: get(bookingInfo, 'payment_type', 1),
              service_fee: get(bookingInfo, 'service_fee', 0),
              amount_booking: get(bookingInfo, 'amount_booking', 0),
              surcharge_total: get(bookingInfo, 'surcharge_total', 0),
              unchoosable: parseInt(get(bookingInfo, 'unchoosable', 0)),
              paymentUrl: get(bookingInfo, 'paymentUrl', ''),
              pickup_address: get(bookingInfo, 'pickup_address', ''),
              drop_off_address: get(bookingInfo, 'drop_off_address', ''),
            }
            if (get(bookingInfo, 'partner_code', '')) {
              this.qr = await this.generateQrWithLogo(
                  get(bookingInfo, 'partner_code', '')
              );
            }

            if (this.booking_info.status == 5) {
              this.mode = 'cancel'
            }
          })
          .catch((e) => {
            console.log(e)
            this.loading = false
            this.mode = 'error'
          });
    },
    validate () {
      this.emptyError()
      let result = true

      if (!this.ticket_code) {
        this.errors.ticket_code = this.$t('common.ticket_code_error')
        result = false
      }
      if (!this.phone) {
        this.errors.phone = this.$t('common.phone_error')
        result = false
      }

      return result
    },
    emptyError () {
      this.errors = {
        ticket_code: '',
        phone: '',
        common: '',
      }
    },
    setCancelLoading (val) {
      this.cancel_loading = val
    },
    setMode (mode) {
      this.mode = mode;
    },
    setModeAfterCancel (data) {
      this.mode = data.mode;
      if (data.mode === 'cancel' && data.data === 4) {
        this.is_show_cancel_note = true
      }
    },
    goHome () {
      window.location.href = appUrl;
    },
    goHomeBooking () {
      window.location.href = appUrl + '/' +
          (this.$i18n.locale === "vn" ? 'vn/dat-xe-online.html' : 'sleeper-bus-tickets-booking.html');
    },
    async generateQrWithLogo(code, size = 150) {
      const canvas = document.createElement("canvas");

      await QRCode.toCanvas(canvas, code, {
        width: size,
        margin: 2,
        errorCorrectionLevel: "H"
      });

      const ctx = canvas.getContext("2d");

      const logo = await this.loadImage(this.logo_pt);

      const logoSize = size * 0.2;
      const x = (size - logoSize) / 2;
      const y = (size - logoSize) / 2;

      ctx.fillStyle = "white";
      ctx.fillRect(x, y, logoSize, logoSize);

      ctx.drawImage(logo, x, y, logoSize, logoSize);

      return canvas.toDataURL("image/png");
    },
    loadImage(src) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "anonymous";
        img.onload = () => resolve(img);
        img.onerror = reject;
        img.src = src;
      });
    }
  }
};
</script>
